import { defineMessages } from 'react-intl'

export default defineMessages({
  imageAttachment: {
    id: 'contact.form.attachment.editorImage',
    defaultMessage: 'Priložena slika iz editora',
  },
})
